import { cva } from '@/styled-system/css/cva.mjs';

export const statsContainerStyles = cva({
  base: {
    display: 'flex',
    flexDirection: 'row',
    padding: '{spacing.600} 0',
    marginBottom: '200',
  },
  variants: {
    canAccessListingQuality: {
      false: {
        borderBottom: '{borderWidths.25} solid {colors.gray300}',
        borderTop: '{borderWidths.25} solid {colors.gray300}',
      },
    },
  },
});
